import { VALID_ALPHANUMERIC_REGEX } from './alphanumeric-key';
import { VALID_EMAIL_REGEX } from './email';
import { VALID_MATERIALNAME_REGEX } from './materialName';
import { VALID_NUMBER_REGEX } from './number';
import { VALID_PASSWORD_REGEX } from './password';
import { VALID_PHONE_REGEX } from './phone';
import { VALID_USERNAME_REGEX } from './userName';
import { VALID_WALLET_ADDRESS_REGEX } from './wallet-address';

export const Pattern = {
  email: VALID_EMAIL_REGEX,
  password: VALID_PASSWORD_REGEX,
  alphanumericKey: VALID_ALPHANUMERIC_REGEX,
  phone: VALID_PHONE_REGEX,
  number: VALID_NUMBER_REGEX,
  username: VALID_USERNAME_REGEX,
  walletAddress: VALID_WALLET_ADDRESS_REGEX,
  materialName: VALID_MATERIALNAME_REGEX
};
